import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface Notification {
    profileImageUrl: any;
    id: any;
    isRead: any;
    title: any;
    body: any;
    sentOn: string | number | Date;

}

interface NotificationState {
    data: Notification[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const URL = import.meta.env.VITE_API_USERS_URL;

export const CustomSearchNotifications = createAsyncThunk<
    Notification[],
    { userProfileId?: any },
    { rejectValue: string }
>(
    'notification/CustomSearchNotifications',
    async (params, { rejectWithValue }) => {
        try {
            const config = params?.userProfileId ? { params } : {};

            const response = await apiService.get<any>(
                'custom_search_notifications',
                PORT,
                URL,
                config
            );

            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);
export const updateNotification = createAsyncThunk<Notification, any, { rejectValue: string }>(
    'notification/updateNotification',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: Notification }>(
                '/update_notification',
                params,
                PORT,
                URL,
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    },
);
export const softDeleteNotification = createAsyncThunk<{ id: number }, number, { rejectValue: string }>(
    'notification/softDeleteNotification',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.patch<{ data: { id: number } }>(
                `/soft_delete_food_pack_unit?id=${id}`,
                {},
                PORT,
                URL,
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error instanceof Error ? error.message : 'An error occurred while deleting pack unit',
            );
        }
    },
);

export const NotificationSlice = createSlice({
    name: 'notification',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as NotificationState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(CustomSearchNotifications.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(CustomSearchNotifications.fulfilled, (state, action: PayloadAction<Notification[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(CustomSearchNotifications.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateNotification.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateNotification.fulfilled, (state, action: PayloadAction<Notification>) => {
                state.loading = false;
                state.data = [action.payload];
            })
            .addCase(updateNotification.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            });


    },
});

export default NotificationSlice.reducer;
